export default __webpack_public_path__ + "static/media/1850.796b9179.png";